import { DigitalNavigationStep, NavigationContext, PrintNavigationStep } from '../CardCustomizer.types';
import { createContext } from '@shared/utils/createContext';

const [NavigationProvider, useNavigationContext] = createContext<NavigationContext<PrintNavigationStep>>({ name: 'Navigation' });
const [DigitalNavigationProvider, useDigitalNavigationContext] = createContext<NavigationContext<DigitalNavigationStep>>({ name: 'Navigation' });

export { NavigationProvider, useNavigationContext, DigitalNavigationProvider, useDigitalNavigationContext };

export const printNavigationStepToLabel: Record<PrintNavigationStep, string> = {
  cardFront: 'Edit Front',
  cardBack: 'Edit Back', // Button saying "Next: Back" is confusing, so we're using "Next: Edit Back"
  envelope: 'Envelope',
  recipients: 'Recipients',
  review: 'Review',
  postCheckout: 'Post Checkout',
};
